import { getApv } from '../../apis';
import { setAddEventListener, setIframeInnerHtml } from '../../helpers';

const AgreeOpenBanking = {
  accountList: [],

  render: async () => {
    const res = await getApv('common/agreeBankInfo');
    AgreeOpenBanking.accountList = res.accountList.map((a) => {
      const bnkCode = res.bnkList.filter((aa) => aa.codeId === a.bnkCode)[0];

      return {
        ...a,
        bnkName: bnkCode != null ? bnkCode.codeName : '',
      };
    });

    return `
        <div>
          <a id="connect_pay_back_button" class="c_back"></a>
        </div>
        <div class="c_title1">오픈뱅킹 출금이체 동의 정보</div>
        <div class="p_lr_10" id="agreement_open_banking_list">
        </div>
    `;
  },

  afterRender: async () => {
    let listHtml = '';

    for (const item of AgreeOpenBanking.accountList) {
      listHtml += `<div class="m_b_20">
                     <div class="c_bod1 c_box">
                         <div class="c_label5">동의 날짜</div>
                         <div class="c_label1">${item.entyDt.replace(
                           /^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/,
                           '$1년 $2월 $3일 $4:$5'
                         )}</div>
                     </div>
                     <div class="c_bod1 c_box skin1_bod">
                       <div class="c_label5">동의 기관</div>
                       <div class="c_label1">${item.bnkName}</div>
                     </div>
                   </div>`;
    }
    setIframeInnerHtml('agreement_open_banking_list', listHtml);
    // SetEvents
    setAddEventListener('connect_pay_back_button', () => history.back());
  },
};
export default AgreeOpenBanking;
